import React from 'react';
import ReactDOM from 'react-dom/client';

import OpeningHoursSingle from './OpeningHoursSingle';

const root = ReactDOM.createRoot(
  document.getElementById('opening_hours_single')
);

root.render(
  <React.StrictMode>
    <OpeningHoursSingle />
  </React.StrictMode>
);
